import React from 'react';
import { useSelector } from 'react-redux';
import { AppStore } from '../store/applicationState';
import { TYPE_ID } from '../utils/consts';

let isSendUavideo = false;

export const useActionsMarketing = () => {
  const { Sockets } = useSelector((store: AppStore) => store);

  const loadedVideo = React.useCallback(() => {
    if (isSendUavideo) return null;

    //@ts-ignore
    if (typeof window.AuthButton?.saveAction !== 'function') return null;
    if (!Sockets.event) return null;
    if (!Sockets.event.baseProduct || !Sockets.event.product_id) return null;
    if (![TYPE_ID.WEBINAR, TYPE_ID.SEMINAR].includes(Sockets.event.type_id)) return null;

    isSendUavideo = true;

    //@ts-ignore
    window.AuthButton.saveAction([7, 'uavideo', window.location.href, Sockets.event.baseProduct, Sockets.event.product_id]);
  }, [Sockets.event]);

  const clickCerteficate = React.useCallback(() => {
    //@ts-ignore
    if (typeof window.AuthButton?.saveAction !== 'function') return null;
    if (!Sockets.event) return null;
    if (!Sockets.event.baseProduct || !Sockets.event.product_id) return null;

    //@ts-ignore
    window.AuthButton.saveAction([8, 'uasertyfikat', window.location.href, Sockets.event.baseProduct, Sockets.event.product_id]);
  }, [Sockets.event]);

  return { loadedVideo, clickCerteficate };
};
